import {FETCH_SCOPEACTIVITY_REQUEST, FETCH_SCOPEACTIVITY_SUCCES, FETCH_SCOPEACTIVITY_ERROR} from '../constants/ScopeActivity'
import { jsonGet, errorHandler } from '../utils/Request';
import getFilterParameters from '../utils/getFilterParameters';

const loadScopeActivity = (filter) => (dispatch) => {
  const parameters = getFilterParameters(filter, 'scope_activity');
  const apiUrl = `/personal/scope-activity/list/${parameters ? parameters : '' }`;
  dispatch({
    type: FETCH_SCOPEACTIVITY_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_SCOPEACTIVITY_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_SCOPEACTIVITY_ERROR
      });
      errorHandler(e);
    });
};

export { loadScopeActivity };



// WEBPACK FOOTER //
// ./src/actions/ScopeActivityActions.js